import { Injectable } from "@angular/core";
import { ConfigurationService } from "../../configuration/configuration-service";

@Injectable()
export class Paths {
	private V1: string;
	constructor(private configurationService: ConfigurationService) {
		this.V1 = this.configurationService.servicePaths.get("GESTIONE_PAGAMENTI_MS_API_URL") + "/v1/";
	}

	get_V1_CRONOLOGIA_STATI(idPagamento): string {
		return this.V1 + 'cronologia/' + idPagamento;
	}
}